module.exports = __webpack_public_path__ + "static/media/neo-sans-regular.08618401.woff2";